import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import { Box, Button, Tooltip } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Link } from 'react-scroll';
import { Spinner } from './Spinner';

export const LetsGoBtn = ({
  width,
  margin,
  className = '',
  text = 'Нумо гляньмо',
  colorScheme = 'blue',
  lineHeight,
  borderRadius = '40px',

  ...props
}) => {
  const getStyles = (scheme) => {
    switch (scheme) {
      case 'blue':
        return {
          width: width,
          textTransform: 'inherit',
          borderRadius: borderRadius,
          padding: { xs: '8px 10px', sm: '8px 15px' },
          margin: margin,
          backgroundColor: '#60A5DF',
          boxShadow: 'none',
          color: 'white',
          maxHeight: '54px',
          fontSize: { xs: '14px', sm: '18px' },
          fontFamily: 'FixelText-Medium',
          fontWeight: '500',
          lineHeight: lineHeight ? lineHeight : 'unset',
          ':hover': {
            backgroundColor: 'white',
            color: '#60A5DF',
            boxShadow: '0px 0px 0px 2px #60a5df inset'
          }
        };
      case 'red':
        return {
          width: width,
          textTransform: 'inherit',
          borderRadius: borderRadius,
          padding: { xs: '8px 10px', sm: '8px 15px' },
          margin: margin,
          backgroundColor: '#FFE5E5',
          boxShadow: 'none',
          color: '#F64D36',
          maxHeight: '54px',
          fontSize: { xs: '14px', sm: '18px' },
          lineHeight: lineHeight ? lineHeight : 'unset',
          fontFamily: 'FixelText-Medium',
          fontWeight: '500',
          ':hover': {
            backgroundColor: 'white',
            color: '#F64D36 !important',
            boxShadow: '0px 0px 0px 2px #F64D36 inset !important'
          }
        };
      case 'white':
        return {
          width: width,
          textTransform: 'inherit',
          borderRadius: borderRadius,
          padding: { xs: '8px 10px', sm: '8px 15px' },
          margin: margin,
          backgroundColor: 'white',
          boxShadow: '0px 0px 0px 2px #60a5df inset',
          color: '#60A5DF',
          maxHeight: '54px',
          fontSize: { xs: '14px', sm: '18px' },
          fontFamily: 'FixelText-Medium',
          fontWeight: '500',
          lineHeight: lineHeight ? lineHeight : 'unset',
          ':hover': {
            backgroundColor: '#60A5DF !important',
            color: 'white !important',
            boxShadow: 'none'
          }
        };
      default:
        return {
          width: width,
          textTransform: 'inherit',
          borderRadius: '40px',
          padding: { xs: '8px 10px', sm: '8px 15px' },
          margin: margin,
          backgroundColor: '#60A5DF',
          boxShadow: 'none',
          color: 'white',
          maxHeight: '54px',
          fontSize: { xs: '14px', sm: '18px' },
          fontFamily: 'FixelText-Medium',
          fontWeight: '500',
          lineHeight: lineHeight ? lineHeight : 'unset',
          ':hover': {
            backgroundColor: 'white',
            color: '#60A5DF',
            boxShadow: '0px 0px 0px 2px #60a5df inset'
          }
        };
    }
  };
  return (
    <Button
      {...props}
      variant="contained"
      className={className}
      sx={{ ...getStyles(colorScheme), ...props.sx }}
    >
      {text}
    </Button>
  );
};
export const LetsGoBtn3 = ({
  width,
  margin,
  padding = '10px',
  text = 'LetsGoBtn3',
  onClick,
  colorScheme = 'blue',
  ...props
}) => (
  <Button
    {...props}
    onClick={onClick}
    variant="contained"
    sx={{
      display: 'block !important',
      zIndex: '998 !important',
      width: width,
      textTransform: 'inherit !important',
      borderRadius: '40px !important',
      padding: padding,
      margin: margin,
      backgroundColor: colorScheme === 'blue' ? '#60A5DF' : 'white',
      boxShadow: colorScheme === 'blue' ? 'none' : '0px 0px 0px 2px #60a5df inset',
      color: colorScheme === 'blue' ? 'white' : '#60A5DF',
      border: 'none !important',

      ':hover': {
        backgroundColor: colorScheme === 'blue' ? 'white' : '#60A5DF !important',
        color: colorScheme === 'blue' ? '#60A5DF' : 'white !important',
        boxShadow: colorScheme === 'blue' ? '0px 0px 0px 2px #60a5df inset' : 'none'
      }
    }}
  >
    {text}
  </Button>
);
export const LetsGoBtn2 = ({
  text = 'Гайда дивитись!',
  onClick,
  icon = false,
  usedIcon,
  colorScheme = 'blue',
  margin = '0px 0px 0px 16px',
  width = '250px',
  ...props
}) => (
  <Button
    {...props}
    variant="contained"
    onClick={onClick}
    sx={{
      width: width,
      textTransform: 'inherit',
      borderRadius: '40px',
      padding: '10px',
      backgroundColor: colorScheme === 'blue' ? '#60A5DF' : 'white',
      boxShadow: colorScheme === 'blue' ? 'none' : '0px 0px 0px 2px #60a5df inset',
      color: colorScheme === 'blue' ? 'white' : '#60A5DF',
      border: 'none !important',

      margin: margin,
      '&.MuiButtonBase-root.MuiButton-root.Mui-disabled': {
        color: 'rgb(159 159 159) !important',
        boxShadow: 'none !important',
        backgroundColor: 'rgb(237 237 237) !important',
        border: '1px solid rgb(159 159 159) !important',
        margin: margin
      },
      ':hover': {
        backgroundColor: colorScheme === 'blue' ? 'white' : '#60A5DF !important',
        color: colorScheme === 'blue' ? '#60A5DF' : 'white !important',
        boxShadow: colorScheme === 'blue' ? '0px 0px 0px 2px #60a5df inset' : 'none'
      }
    }}
  >
    {icon ? <>{icon && !usedIcon ? <PermIdentityIcon sx={{ mr: 1 }} /> : usedIcon}</> : null}

    {text}
  </Button>
);
export const ContactsBtn = ({ onClick, ...props }) => (
  <Button
    {...props}
    onClick={onClick}
    variant="contained"
    style={{
      width: props?.isInContacts ? '50px' : '150px',
      textTransform: 'inherit',
      borderRadius: '40px',
      padding: '10px',
      backgroundColor: '#FFFFFF',
      border: props.disabled ? '1px solid lightgray' : '1px solid black',
      boxShadow: 'none',
      color: props.disabled ? 'lightgray' : 'black',
      fontSize: '13px'
    }}
  >
    {props?.isInContacts ? (
      <Tooltip title="Видалити з контактів">
        {!props?.isFetching ? (
          <PersonOffOutlinedIcon sx={{ fontSize: '20px', color: '#60A5DF' }} />
        ) : (
          <Spinner type="small" />
        )}
      </Tooltip>
    ) : (
      <>
        {!props?.isFetching ? (
          <AddIcon sx={{ color: '#60A5DF', mr: 1 }} />
        ) : (
          <Spinner type="small" />
        )}
      </>
    )}

    {props?.isInContacts ? '' : 'Контакти'}
  </Button>
);
export const FreeBtn = ({
  onClick,
  icon,
  text = 'Button text',
  padding = '14.5px 24px',
  disabled,
  ...props
}) => (
  <Button
    {...props}
    disabled={disabled}
    onClick={onClick}
    className={disabled && 'btnDisabled'}
    variant="contained"
    style={{
      textTransform: 'inherit',
      borderRadius: '40px',
      padding: padding,
      backgroundColor: '#FFFFFF',
      border: !disabled ? '1px solid black' : '1px solid lightgray',
      boxShadow: 'none',
      color: !disabled ? 'black' : 'lightgray',
      zIndex: 99
    }}
  >
    {icon && icon}
    {text !== 'Button text' || text.length !== 0 ? text : null}
  </Button>
);
export const ToTopBtn = ({ icon, visible, to = 'topSearch', offset = -100, ...props }) => (
  <Link
    to={to}
    spy={true}
    smooth={true}
    offset={offset}
    duration={1000}
    style={{
      height: '22px',
      width: '22px',
      position: 'fixed',
      right: '120px',
      bottom: '100px',
      zIndex: 999
    }}
  >
    <Button
      {...props}
      variant="contained"
      style={{
        textTransform: 'inherit',
        borderRadius: '30px',
        backgroundColor: '#60A5DF',
        boxShadow: 'none',
        color: 'white',
        zIndex: 999,
        padding: '15px',
        minWidth: '50px',
        position: 'fixed',
        right: '25px',
        bottom: '100px',
        visibility: visible ? 'visible' : 'hidden'
      }}
    >
      {icon && icon}{' '}
    </Button>
  </Link>
);
export const ToTopBtnFree = ({ icon, visible, top = '60%', ...props }) => (
  // <Box
  //   style={{ height: '22px', width: '22px', position: 'fixed', right: '120px', bottom: '100px' }}
  // >
  <Button
    {...props}
    variant="contained"
    sx={{
      textTransform: 'inherit',
      borderRadius: '30px',
      backgroundColor: '#60A5DF',
      boxShadow: 'none',
      color: 'white',
      zIndex: 999,
      padding: '15px',
      minWidth: '50px',
      position: 'absolute',
      right: { xs: '-0px', sm: '-60px' },
      top: top,
      visibility: visible ? 'visible' : 'hidden'
    }}
  >
    {icon && icon}{' '}
  </Button>
  // </Box>
);
export const PlusBtn = ({ onClick }) => (
  <Button
    onClick={onClick}
    variant="contained"
    style={{
      textTransform: 'inherit',
      borderRadius: '40px',
      padding: '14.5px 28px',
      backgroundColor: '#FFFFFF',
      border: '1px solid black',
      boxShadow: 'none',
      color: 'black'
    }}
  >
    <AddIcon sx={{ fontSize: '30px' }} htmlColor="#60A5DF" />
  </Button>
);
export const IncrementBtn = ({
  setter,
  value,
  // initOfMeasure,
  disableIncrement = false,
  disableDecrement = false,
  colorOfQty
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-around',
      minWidth: '135px ',
      alignItems: 'center'
    }}
  >
    <Button
      onClick={() => setter(value - 1)}
      disabled={disableDecrement}
      variant="contained"
      id="buttonDecrement"
      sx={{
        textTransform: 'inherit',
        borderRadius: '20px',
        padding: '0px',
        backgroundColor: '#e2f2ff',
        border: 'none',
        boxShadow: 'none',
        color: 'black',
        minWidth: 'unset',
        width: '40px !important',
        height: '40px !important'
      }}
    >
      <RemoveIcon
        sx={{
          color: 'black',
          fontSize: '21px',
          ':hover': {
            color: '#60A5DF'
          }
        }}
      />
    </Button>
    {/* {`${value} ${initOfMeasure}.`} */}
    <p style={{ margin: '0', color: colorOfQty }}>{`${value} од.`}</p>
    <Button
      onClick={() => setter(value + 1)}
      variant="contained"
      id="buttonIncrement"
      disabled={disableIncrement}
      sx={{
        textTransform: 'inherit',
        borderRadius: '20px',
        padding: '0px',
        backgroundColor: '#e2f2ff',
        border: 'none',
        boxShadow: 'none',
        color: 'black',
        minWidth: 'unset',
        width: '40px !important',
        height: '40px !important'
      }}
    >
      <AddIcon
        sx={{
          color: 'black',
          fontSize: '21px',
          ':hover': {
            color: '#60A5DF'
          }
        }}
      />
    </Button>
  </Box>
);
